import { useQuery } from '@apollo/client/react';
import { css } from '@emotion/react';
import { Box, Typography } from '@mui/material';
import { Types } from '@scorenco/core';

import { GetTournamentChallengeRankingDocument } from './_internal/GetTournamentChallengeRanking.query.generated';

export const TournamentChallengeRanking = ({
  screen,
}: {
  screen: Types.Clubhouse_Screen;
}) => {
  const challengeId = screen.challenge_id;

  const tournamentChallengeRanking = useQuery(
    GetTournamentChallengeRankingDocument,
    {
      variables: {
        id: challengeId ?? 0,
      },
      skip: !challengeId,
      context: {
        role: 'anonymous',
      },
    }
  );

  const challenge =
    tournamentChallengeRanking.data?.tournaments_challenge_by_pk;

  if (!challenge) {
    return null;
  }

  const teams = challenge.teams ?? [];

  const columnCount = teams.length > 16 ? 2 : 1;

  return (
    <Box>
      <Typography
        variant="h1"
        sx={{
          m: 0,
          textAlign: 'center',
          marginTop: '3rem',
        }}
      >
        Classement général {challenge?.name}
      </Typography>
      <Typography
        variant="h2"
        sx={{
          m: 0,
          textAlign: 'center',
          mb: 4,
        }}
      >
        {challenge?.tournament?.name}
      </Typography>

      <div
        css={css`
          display: flex;
          padding: 0.25rem 1rem;
        `}
      >
        <div
          css={css`
            flex: 1;
            font-size: 0.75rem;
          `}
        />
      </div>

      <div
        css={css`
          display: grid;
          grid-template-columns: repeat(${columnCount}, 1fr);
          grid-auto-flow: column;
          gap: 1rem;
        `}
      >
        {Array(teams.length)
          .fill(0)
          .map((_, i) => (
            <div
              key={i}
              css={css`
                display: flex;
                border: 1px solid #e2e8ed;
                background: white;
                padding: 0.5rem 1rem;
                margin-top: -1px;
                font-size: 0.875rem;
                font-weight: bold;
                grid-column: ${columnCount === 2 && i + 1 > 14 ? 2 : 1};
              `}
            >
              <div
                css={css`
                  flex: 0 0 1.5rem;
                  text-align: center;
                `}
              >
                {i + 1}
              </div>
              <div
                css={css`
                  margin-left: 0.25rem;
                  flex: 1;
                `}
              >
                {teams.find((team) => team.rank === i + 1)?.name || '-'}
              </div>
            </div>
          ))}
      </div>
    </Box>
  );
};
